import { FormatSupplierBillingAddressSupplierFragment } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'

export function formatSupplierBillingAddress(supplier: FormatSupplierBillingAddressSupplierFragment | null): string {
  const {
    billingAddressLine1,
    billingAddressLine2,
    billingAddressCity,
    billingAddressStateProvince,
    billingAddressPostalCode,
  } = supplier || {}

  const arr: string[] = [
    billingAddressLine1,
    billingAddressLine2,
    billingAddressCity,
    billingAddressStateProvince,
    billingAddressPostalCode,
  ]
    .filter((e) => Boolean(e))
    .map((e) => String(e))

  return arr.reduce((acc, curr) => `${acc} ${curr}`, '').trim()
}
